let language = {
    QP_LAZY_IMAGE_ERROR_TITLE: "单击即可再次重新加载图像。",
};

export { language }